var AssetType;
(function (AssetType) {
    AssetType[AssetType["js"] = 0] = "js";
    AssetType[AssetType["css"] = 1] = "css";
})(AssetType || (AssetType = {}));
var HostEnvironment;
(function (HostEnvironment) {
    HostEnvironment["development"] = "development";
    HostEnvironment["staging"] = "staging";
    HostEnvironment["production"] = "production";
})(HostEnvironment || (HostEnvironment = {}));
var SkeletonEvent;
(function (SkeletonEvent) {
    SkeletonEvent["SkeletonCreated"] = "skeleton_created";
    // getAllMfs
    SkeletonEvent["GetAllMfsStart"] = "get_all_mfs_start";
    SkeletonEvent["GetAllMfsSuccess"] = "get_all_mfs_success";
    SkeletonEvent["GetAllMfsError"] = "get_all_mfs_error";
    // initialization
    SkeletonEvent["InitMF"] = "init_mf";
    SkeletonEvent["MFLoadStart"] = "mf_load_start";
    SkeletonEvent["PrefetchMF"] = "prefetch_mf";
    // meta data
    SkeletonEvent["MFNotInList"] = "mf_not_in_list";
    SkeletonEvent["UseLocalMetaData"] = "use_local_meta_data";
    SkeletonEvent["StartFetchingMetaData"] = "start_fetching_meta_data";
    SkeletonEvent["SuccessFetchingMetaData"] = "success_fetching_meta_data";
    SkeletonEvent["ErrorFetchingMetaData"] = "error_fetching_meta_data";
    // manifest
    SkeletonEvent["StartFetchingManifest"] = "start_fetching_manifest";
    SkeletonEvent["SuccessFetchingManifest"] = "sucess_fetching_manifest";
    SkeletonEvent["ErrorFetchingManifest"] = "error_fetching_manifest";
    SkeletonEvent["FallbackFetchingManifestSuccess"] = "fallback_fetching_manifest_success";
    SkeletonEvent["FallbackFetchingManifestFail"] = "fallback_fetching_manifest_fail";
    // externals
    SkeletonEvent["SharedDependenciesLoadStart"] = "shared_dependencies_load_start";
    SkeletonEvent["SharedDependenciesLoadEnd"] = "shared_dependencies_load_end";
    // loading assets
    SkeletonEvent["StartLoadingJsAssets"] = "start_loading_js_assets";
    SkeletonEvent["SuccessLoadingJsAssets"] = "sucsess_loading_js_assets";
    SkeletonEvent["SuccessLoadingJSAsset"] = "sucsess_loading_js_asset";
    SkeletonEvent["ErrorLoadingJSAsset"] = "error_loading_js_assets";
    SkeletonEvent["SuccessLoadingCSSAsset"] = "sucsess_loading_css_asset";
    SkeletonEvent["ErrorLoadingCSSAsset"] = "error_loading_asset_css";
    // preFetch mf
    SkeletonEvent["StartPreFetchMF"] = "start_prefetch_mf";
    SkeletonEvent["ErrorPreFetchMF"] = "error_prefetch_mf";
    // mf lifecycles
    SkeletonEvent["MfUserInitStart"] = "mf_user_init_start";
    SkeletonEvent["MfUserInitSuccess"] = "mf_user_init_success";
    SkeletonEvent["MfUserInitError"] = "mf_user_init_error";
    SkeletonEvent["MfUserRenderStart"] = "mf_user_render_start";
    SkeletonEvent["MfUserRenderSuccess"] = "mf_user_render_success";
    SkeletonEvent["MfUserRenderError"] = "mf_user_render_error";
    SkeletonEvent["MfUserUpdateInitialDataError"] = "mf_user_update_initial_data_error";
    SkeletonEvent["MfUseruUnmountError"] = "mf_user_unmount_error";
    SkeletonEvent["MFLoadDone"] = "mf_load_done";
})(SkeletonEvent || (SkeletonEvent = {}));

export { AssetType, HostEnvironment, SkeletonEvent };
